import React, { useEffect, useState, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useGetSearchProductListQuery } from "../../../utils/api/product/product.api";
import { formatCurrency, getImage, normalize, fuzzyMatch } from "../../../utils/Utils";
import { AlertInfo } from "../../common/Alert";
import Empty from "../../../assets/images/appImages/category.png";
import { getVendeur } from "../../HomePage/HomePage";
import { getProductPriceLabels } from "../../../utils/productPricing";

function SearchForm() {
  const Vendeur = getVendeur();
  const navigate = useNavigate();
  const [isDivVisible, setIsDivVisible] = useState(false);
  const { slug } = useParams<{ slug: string }>();
  const [query, setQuery] = useState("");

  const { data = { results: [] } } = useGetSearchProductListQuery(
    { q: "" },
    { skip: query.length < 3 }
  );

  useEffect(() => {
    setQuery("");
  }, [slug]);

  const filteredResults = useMemo(() => {
    if (!query || query.length < 3) return [];
    if (!data?.results?.length) return [];
    return data.results.filter((item: any) =>
      fuzzyMatch(item?.nom || "", query)
    );
  }, [data?.results, query]);

  const handleChangeSearch = (e: any) => {
    const val = e?.target?.value;
    setQuery(val);
    setIsDivVisible(val.length >= 3);
  };

  
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && query.trim().length >= 3) {
      setIsDivVisible(false);
      navigate(`/produits?q=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <div className="input-group-search relative-search-form">
      <div style={{ position: "relative" }}>
        <span className="input-group-btn">
          <i className="fa fa-search"></i>
        </span>
        <input
          type="text"
          className="form-control search-field"
          value={query}
          onChange={handleChangeSearch}
          onKeyDown={handleKeyDown}
          onBlur={() => setTimeout(() => setIsDivVisible(false), 300)}
          placeholder="Rechercher un produit"
        />
        {isDivVisible && query && query.length >= 3 && (
          <div className="list-container">
            <ul className="search-result-container">
              {filteredResults?.length ? (
                filteredResults.map((item: any) => (
                  <li className="search-result-item" key={item?.id}>
                    <Link
                      to={`/produit/${item?.slug}`}
                      state={item}
                      className="no-link"
                    >
                      <div className="row align-items-center">
                        <div className="col-sm-3 m-b-10 m-r-3">
                          <img
                            loading="lazy"
                            className="img-thumbs-commande-item"
                            src={getImage(
                              item?.type === "taille_unique"
                                ? item?.images[0]?.image
                                : item?.variations &&
                                  item?.variations[0]?.images
                                ? item?.variations[0]?.images[0]?.image
                                : Empty
                            )}
                            alt={item?.nom}
                            style={{ width: "63px", height: "63px" }}
                          />
                        </div>
                        <div className="pl-lg-0 col-sm-8 m-b-10">
                          <p className="name-prduct-search fs-15">{item?.nom}</p>
                          <div className="content-price-product-solde justify-content-start align-items-baseline">
                            {!!item?.id && (
                              <p className="price-solde-product-item mb-0">
                                {getProductPriceLabels(item, Vendeur?.devise).display}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </Link>
                  </li>
                ))
              ) : (
                <li className="search-result-item">
                  <AlertInfo message="Aucun résultat trouvé!" />
                </li>
              )}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default SearchForm;